import {
  EPublicI9Status,
  EEVerifyPublicCaseStatus,
  EI9AdminReviewStatus,
  ETimePeriod,
  zSchema,
} from "@zeal/common";

export const getWorkerI9MetricsAndStatsCustomPeriodSchema = zSchema.object({
  period: zSchema.literal(ETimePeriod.Custom),
  date_from: zSchema.string(),
  date_to: zSchema.string(),
});

export const getWorkerI9MetricsAndStatsPresetPeriodSchema = zSchema.object({
  period: zSchema.enum(["7d", "14d", "30d", "60d", "90d"]),
});

export const getWorkerI9MetricsAndStatsRequestSchema =
  zSchema.discriminatedUnion("period", [
    getWorkerI9MetricsAndStatsCustomPeriodSchema,
    getWorkerI9MetricsAndStatsPresetPeriodSchema,
  ]);

export const getWorkerI9MetricsAndStatsResponseSchema = zSchema.object({
  metrics: zSchema.object({
    average_duration: zSchema.number().nullable(),
    conversion_rate: zSchema.number().nullable(),
    success_rate: zSchema.number().nullable(),
  }),
  previous_metrics: zSchema
    .object({
      average_duration: zSchema.number().nullable(),
      conversion_rate: zSchema.number().nullable(),
      success_rate: zSchema.number().nullable(),
    })
    .nullable(),
  statistics: zSchema.object({
    public_i9_status: zSchema.record(
      zSchema.nativeEnum(EPublicI9Status),
      zSchema.number()
    ),
    latest_admin_review_status: zSchema.record(
      zSchema.nativeEnum(EI9AdminReviewStatus),
      zSchema.number()
    ),
    everify_status: zSchema.record(
      zSchema.nativeEnum(EEVerifyPublicCaseStatus),
      zSchema.number()
    ),
  }),
  date_range: zSchema.object({
    from: zSchema.string(),
    to: zSchema.string(),
  }),
  previous_date_range: zSchema.object({
    from: zSchema.string(),
    to: zSchema.string(),
  }),
});

// Type exports
export type TGetWorkerI9MetricsAndStatsRequest = zSchema.infer<
  typeof getWorkerI9MetricsAndStatsRequestSchema
>;
export type TGetWorkerI9MetricsAndStatsResponse = zSchema.infer<
  typeof getWorkerI9MetricsAndStatsResponseSchema
>;
